import * as TransportistReducer from './transportist';

const Reducers = {
  ...TransportistReducer,
};

export default Reducers;
